import styled from 'styled-components';

const separator = styled.div`
  position: relative;
  height: 1px;
  
  :before {
    content: "";
    position: absolute;
    top: 0;
    left: 5%;
    right: 5%;
    width: 90%;
    height: 1px;
    background-image: linear-gradient(to right, transparent, #a98e67, transparent);
  }

  :after {
    content: "";
    position: absolute;
    z-index: 1;
    top: -7px;
    left: calc(50% - 7px);
    width: 14px;
    height: 14px;
    transform: rotate(45deg);
    background-color: #131313;
    ${({ white }) => (white ? 'background-color: #FFF;' : '')}
    border-bottom: 1px solid #a98e67;
    border-right: 1px solid #a98e67;
  }
`

export default separator